let Constants = {};

export default Object.seal(Constants);
